import { InfoCircleOutlined } from '@ant-design/icons';
import classNames from 'classnames';

import './RenderInfo.scss';

type RenderInfoProps = {
  title: string;
  content?: string;
  id?: string;
  hasAmountDescription?: boolean;
  isTextGrey?: boolean;
};

export const RenderInfo = ({
  title,
  content,
  id,
  hasAmountDescription = false,
  isTextGrey,
}: RenderInfoProps) => {
  return (
    <div className="render-info">
      <div className="render-info-title">{title}</div>
      <div
        className={classNames([
          'render-info-content',
          { 'text-grey': isTextGrey },
        ])}
        id={id}
      >
        {content}
      </div>
      {hasAmountDescription && (
        <div className="render-info-description">
          <InfoCircleOutlined />
          Please credit the exact indicated amount.
        </div>
      )}
    </div>
  );
};
